// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"0e4b65c0","498":"f5331fc8","703":"9cc530ba","787":"9a649eea"}[chunkId] + ".chunk.js";
};